import Link from "next/link";

export default function Button({
  className = "",
  ahref = "",
  href,
  emphasis = null,
  height = null,
  rounded = true,
  isDiv = false,
  ...props
}) {
  const emphasisStyles = () => {
    switch (emphasis) {
      case "primary":
        return "bg-yellow-400 border-yellow-400 text-white hover:bg-yellow-500 hover:border-yellow-500";
      case "secondary":
        return "bg-yellow-300 border-yellow-300 text-yellow-700 hover:bg-yellow-200 hover:border-yellow-200";
      case "primaryHollow":
        return "bg-transparent border-yellow-400 text-yellow-400 hover:border-yellow-500";
      case "marketingPrimary":
        return "bg-red border-red px-8 rounded-full text-white hover:bg-red-300 hover:border-red-300";
      case "text":
        return "bg-transparent border-none text-black hover:text-gray-600 font-semibold";
      case "black":
        return "bg-black border-black text-white hover:text-gray-300 font-semibold";
      default:
        return null;
    }
  };

  const heightStyles = () => {
    switch (height) {
      case "23":
        return "py-0.5 text-xs";
      case "28":
        return "py-1 text-sm";
      case "32":
        return "py-1.5 text-sm";
      case "36":
        return "py-2 text-sm";
      case "40":
        return "py-2.5 text-sm";
      case "44":
        return "py-3 text-sm";
      case "50":
        return "py-3.5 text-sm";
      default:
        return null;
    }
  };

  const roundedStyles = () => {
    if (rounded) {
      return "rounded-md";
    }
    return null;
  };

  return ahref ? (
    <a href={ahref}>
      <button
        className={`border border-solid duration-300 flex-shrink-0 font-semibold inline-flex items-center justify-center px-3 transition focus:outline-none ${roundedStyles()} ${emphasisStyles()} ${heightStyles()} ${className}`}
        {...props}
      />
    </a>
  ) : href ? (
    <Link href={href}>
      <button
        className={`border border-solid duration-300 flex-shrink-0 font-semibold inline-flex items-center justify-center px-3 transition focus:outline-none ${roundedStyles()} ${emphasisStyles()} ${heightStyles()} ${className}`}
        {...props}
      />
    </Link>
  ) : isDiv ? (
    <div
      className={`border border-solid duration-300 flex-shrink-0 font-semibold inline-flex items-center justify-center px-3 transition focus:outline-none ${roundedStyles()} ${emphasisStyles()} ${heightStyles()} ${className}`}
      {...props}
    >
      {props.children}
    </div>
  ) : (
    <button
      className={`border border-solid duration-300 flex-shrink-0 font-semibold inline-flex items-center justify-center px-3 transition focus:outline-none ${roundedStyles()} ${emphasisStyles()} ${heightStyles()} ${className}`}
      {...props}
    />
  );
}
